import { MdClose } from "react-icons/md";
import { useDispatch } from "react-redux";
import { ApproveRefundRequest } from "../../../Redux/Action/MasterAdminAction";
import { useState } from "react";
import { RejectReasonModel } from "./RejectReasonModel";
import { ApproveSureModel } from "./ApproveSureModel";
import Swal from "sweetalert2";

export const RefundApproveModal = ({ setRefundModal , userDetail,refundModal}) => {
  
  const dispatch = useDispatch();

  const handleRefundRequest = async () => {
    try {
      const data={
        req_id:userDetail?.req_id,
        request_status:true
      }
      setRefundModal(false);
      dispatch(ApproveRefundRequest(data, setRefundModal));
    } catch (error) {
    }
  };

  const [rejectReasonModel, setRejectReasonModel] = useState(false);
  const [approveReasonModel, setApproveReasonModel] = useState(false);
  const handelApproveRequest = async () => {
    Swal.fire({
          title: "Are you sure?",
          text: "You want to approve this request!",
          icon: "warning",
          iconColor: "#FCDD00",
          showCancelButton: true,
          allowOutsideClick: false,
          confirmButtonText: "Yes, approve it!",
          cancelButtonText: "Cancel",
          confirmButtonColor: "#FCDD00",
          cancelButtonColor: "#FFFCE1",
          customClass: {
            confirmButton: "custom-confirm-button",
            cancelButton: "custom-cancel-button",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            handleRefundRequest();
          }
        });
    };


    const handelReject=()=>{
      setRejectReasonModel(true);
    }


  return (
    <>
    {refundModal && (
          <div
            className="fixed inset-0 z-40 transition-opacity duration-300 bg-black bg-opacity-25"
            onClick={() => setRefundModal(false)}
          />
        )}
      <div
        className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          refundModal ? "translate-x-0" : "translate-x-full"
        } flex flex-col`}
      >
        <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200 bg-[#FCDD00]">
          <div className="flex items-center ">
            <div className="my-[7px] text-xl font-semibold text-gray-900">Payment Refund Request</div>
            </div>
            <button
              onClick={() => {
                setRefundModal(false);
              }}
            >
              <MdClose className="text-2xl text-gray-500 hover:text-black" />
            </button>
          </div>
        <div className="flex-1 p-6 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
          <form onSubmit={handleRefundRequest}>
                  <textarea
                    className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm  outline-[#FCDD00] input w-full cursor-not-allowed "
                    value={userDetail?.refund_reason}
                    rows="10"
                    disabled
                  >
                    {userDetail?.refund_reason}
                  </textarea>
          </form>
        </div>
        <div className="flex flex-row gap-3 p-6 border-t border-gray-200 bg-gray-50">
                {userDetail?.refund_status === "pending" ||
                userDetail?.refund_status === "reject" ? (
                  <div className="w-full gap-3 mt-2 ml-auto md:mt-0 md:flex">
                    {userDetail?.refund_status === "pending" ? (
                      <button
                        onClick={() => {
                         handelReject()
                        }}
                        type="button"
                        className="flex items-center justify-center w-full gap-1 px-5 py-2 text-lg text-red-700 border border-red-700 rounded-lg outline-none cursor-pointer font-Poppins hover:scale-105"
                      >
                        Reject
                      </button>
                    ) : (
                      ""
                    )}
                    {userDetail?.refund_status === "pending" ? (
                       <button
                       onClick={() => {
                         handelApproveRequest()
                       }}
                       type="button"
                       className="bg-[#FCDD00] text-[#1A1A1A] w-full px-5 py-2 rounded-lg font-Poppins text-lg flex items-center justify-center gap-1 cursor-pointer hover:scale-105 outline-none"
                     >
                       Approve
                     </button>
                    ) : (
                      ""
                    )}

                  </div>
                ) : (
                  ""
                )}
        </div>
      </div>
        {rejectReasonModel && (
          <RejectReasonModel
            {...{ setRejectReasonModel, userDetail, setRefundModal ,rejectReasonModel}}
          />
        )}
        {approveReasonModel && (
          <ApproveSureModel
            {...{ setApproveReasonModel, userDetail, setRefundModal }}
          />
        )}
    </>
  );
};
